"use client";

import Image from "next/image";
import CIVRBannerImage from "@/assets/images/ci-vr/ci-vr-banner-image.jpg";
import CIVRInquiryForm from "@/components/forms/civr-inquiry-form";

export interface InquiryCIVRProps {
  id?: string;
  heading?: string;
}

const InquiryCIVR: React.FC<InquiryCIVRProps> = ({
  id = "inquiry-ci-vr",
  heading = "Need more details?",
}) => {
  return (
    <section
      id={id}
      className="bg-white"
      aria-labelledby="inquiry-ci-vr-heading"
    >
      <div className="grid grid-cols-1 gap-4 p-4 md:gap-6 md:px-6 md:py-8 lg:mx-auto lg:max-w-lg lg:gap-6 lg:px-3 lg:py-10">
        <h2
          id="inquiry-ci-vr-heading"
          className="font-montserrat text-heading-4 text-neutral-600 md:text-heading-3 lg:text-heading-2"
        >
          {heading}
        </h2>
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-0">
          <CIVRInquiryForm className="z-10 shadow-[2px_4px_16px_2px_rgba(82,77,75,0.12)] md:shadow-[4px_6px_20px_2px_rgba(82,77,75,0.12)] lg:shadow-[4px_8px_24px_2px_rgba(82,77,75,0.12)]" />
          <div className="relative mx-auto aspect-[766/753] h-full w-3/4 md:w-[400px] lg:aspect-auto lg:h-auto lg:w-full">
            <Image
              className="md:object-contain"
              src={CIVRBannerImage}
              alt="Inquiry CI VR"
              fill
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default InquiryCIVR;
